import React from "react";
import "react-multi-carousel/lib/styles.css";
import { Input } from "../forms/input";
import Image from "../Image";
import CustomCarousel from "./CustomCarousel";
import HomeFooter from "./HomeFooter";
import TopBar from "./TopBar";

export default function LoginLayout({ children }) {
  const expiryTime = new Date("2025-01-26T12:00:00");
  const showMarquee = new Date() < expiryTime;
  const carsouelItems1 = [
    { image: "/images/Dit-ss-mask-1.png" },
    { image: "/images/Dit-ss-mask-2.png" },
    { image: "/images/Dit-ss-mask-3.png" },
    { image: "/images/Dit-ss-mask-4.png" },
    { image: "/images/Dit-ss-mask-5.png" },
    // { text1: "VIEW VALUE", text2: "ACROSS ASSET", text3: "CLASSES" },
    // { text1: "DO MORE ", text2: "WITH EASE AND", text3: "SPEED" },
    // { text1: "DASHBOARD FOR", text2: "EVERYTHING", text3: "" },
    // { text1: "ONE VIEW", text2: "MANY INSIGHTS", text3: "" },
    // { text1: "CONVENIENCE OF", text2: "CONSOLIDATED", text3: "STATEMENTS" },
  ];

  const itemsWithText = [
    {
      text: "One-time Pin/Pattern login",
      img: "/images/dit-app-ss-1.png",
    },
    {
      text: "Dashboard for Everything",
      img: "/images/dit-app-ss-mask-2.png",
    },
    {
      text: "View Value Across Asset Classes",
      img: "/images/dit-app-ss-mask-3.png",
    },
    {
      text: "View Investor Portfolio",
      img: "/images/dit-app-ss-mask-4.png",
    },
    {
      text: "Simplified Client search",
      img: "/images/dit-app-ss-mask-5.png",
    },
    {
      text: "Industry first Phygital mode Transactions",
      img: "/images/dit-app-ss-6.png",
    },
  ];

  return (
    <div className="dit_content_sec">
      <div
        className="login-container"
        style={{
          // overflow: "hidden",
          backgroundSize: "100%",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <TopBar showMarquee={showMarquee}/>
        <div className="max-width">
          <div className={`login-without-appbar ${!showMarquee ? 'banner_login_sec' : ''}`}>
            <div className="banner_left mobile_order">
              <h1>No more multiple apps, logins and updates. </h1>
              <h2>
                {" "}
                <span> KFinKart DIT Platform</span> is the only smart platform
                you need.
              </h2>
              <p className="banner_demart_text">
                It gives you the power to invest, track and manage across a host
                of mutual funds, meeting all your transactions management needs
              </p>
            </div>
            <div
              className="login-right-div banner_right_login"
              // style={{ overflow: "scroll" }}
            >
              {children}
            </div>
          </div>
        </div>
      </div>

      {/* What is KFinKart section */}
      <div className="what_content_sec max-width">
        <div className="row">
          <div className="what_content_left col-md-7">
            <div className="what_div_left">
              <h2>What is KFinKart DIT ?</h2>
              <p>
                Paperless and hassle free Mutual fund transactions Service
                fulfillment on the go at the convenience of your mobile phone or
                desktop No hassle of running around the city for meeting the
                customers for servicing them. No need to rush during peak hours
                to the AMC or R&amp;T branches for submission of application
                forms before the cut off time.
              </p>
            </div>
          </div>
          <div className="what_content_right col-md-5  my-auto">
            <div className="content_div_right">
              <Image src="/images/why_kfinkart.png" />
            </div>
          </div>
        </div>
      </div>
      {/* What is KFinKart section */}

      {/* smart feature section */}
      <div className="smart_feature_sec max-width">
        <h2 className="smart_heading">Smart Features </h2>
        <div className="feature_dflex row">
          <div className="feature_list col-md-4">
            <div className="feature_heding_list">
              <Image src="/images/tick_icon.svg" />
              <h2>Phygital Mode</h2>
            </div>
          </div>
          <div className="feature_list col-md-4">
            <div className="feature_heding_list">
              <Image src="/images/tick_icon.svg" />
              <h2>Digital Mode</h2>
            </div>
          </div>
          <div className="feature_list col-md-4">
            <div className="feature_heding_list">
              <Image src="/images/tick_icon.svg" />
              <h2>eKYC</h2>
            </div>
          </div>
          <div className="feature_list col-md-4">
            <div className="feature_heding_list">
              <Image src="/images/tick_icon.svg" />
              <h2>SIP Summary</h2>
            </div>
          </div>
          <div className="feature_list col-md-4">
            <div className="feature_heding_list">
              <Image src="/images/tick_icon.svg" />
              <h2>AUM Summary</h2>
            </div>
          </div>
          <div className="feature_list col-md-4">
            <div className="feature_heding_list">
              <Image src="/images/tick_icon.svg" />
              <h2>Brokerage Details</h2>
            </div>
          </div>
          <div className="feature_list col-md-4">
            <div className="feature_heding_list">
              <Image src="/images/tick_icon.svg" />
              <h2>Mail Back reports</h2>
            </div>
          </div>

          <div className="feature_sub_list col-md-8">
            <div className="feature_heding_list">
              <Image src="/images/tick_icon.svg" />
              <h2>View Investor Portfolio Summary</h2>
            </div>
          </div>
        </div>
      </div>

      {/* smart feature section end */}

      {/* break section start */}
      <div className="break_sec">
        <div className="break_content_sec">
          <div className="max-width">
            <div className="feature_dflex row">
              <div className="break_left col-md-5">
                <div className="break_unique_left ">
                  <h2 className="unique_feature_heading">Unique Features </h2>
                  <div className="unique_feature_list">
                    <Image src="/images/tick_icon.svg" />
                    <h2>Industry first app for distributors</h2>
                  </div>
                  <div className="unique_feature_list">
                    <Image src="/images/tick_icon.svg" />
                    <h2>Fully digitized transacting platform</h2>
                  </div>
                </div>
              </div>
              <div className="break_right col-md-7">
                <div className="break_unique_left">
                  <h2 className="unique_feature_heading">Upcoming Features </h2>
                  <div className="unique_feature_list">
                    <Image src="/images/tick_icon.svg" />
                    <h2>All asset class provisioning</h2>
                  </div>
                  <div className="unique_feature_list">
                    <Image src="/images/tick_icon.svg" />
                    <h2>Distribution in a box solution</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* break section end */}
      {/* web screenshot section start */}
      <div className="web_sreenshot_sec">
        <div className="max-width">
          <div className="row">
            <div className="col-md-4">
              <div className="web_sreenshot_left">
                <h2>
                  DIT <br />
                  Screenshots
                </h2>
              </div>
            </div>
            <div className="col-md-8">
              <CustomCarousel imageOnly items={carsouelItems1} />
            </div>
          </div>
        </div>
      </div>

      <div className="max-width my-4 app_feature_sec">
        <p
          className="display-4 text-center text-white app_feature_heading"
          style={{
            fontWeight: "bold",
            fontSize: "64px",
            letterSpacing: "0.1px",
          }}
        >
          App Features
        </p>

        <CustomCarousel items={itemsWithText} imageOnly={false} itemCount={3} />
      </div>

      {/* web screenshot section end */}

      {/* download section start */}
      <div className="dwnld_app_sec">
        <div className="max-width">
          <h2 className="dwnld_heading_text">Download Our App Now!</h2>
          {/*Needs to be removed once the download link API is ready*/}
          <div className="dwnld_dit_sec">
            <div className="d-flex justify-content-start">
              <a
                href="https://play.google.com/store/apps/details?id=com.karvydistributor"
                target="_blank"
                style={{ marginRight: "10px" }}
                rel="noopener noreferrer"
              >
                <Image src="/images/google_play.png" />
              </a>
              <a
                href="https://apps.apple.com/in/app/kfinkart-distributors/id1421782361"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Image src="/images/app_store.png" />
              </a>
            </div>
          </div>
          {/*Needs to be removed once the download link API is ready*/}
          {/* <div className="dwnld_dit_sec">
                        <div className="row">
                            <div className="col-md-7">
                                <div className="dwnld_left">
                                    <h2>Download Distributor App</h2>
                                    <p>
                                        Enter Your Mobile number to get App Link
                                    </p>

                                    <div className="dwnld_ip_sec">
                                        <Input
                                            isDark={true}
                                            bordercolor="#fff"
                                            className="mobile_input"
                                            placeholder={"Number"}
                                            name={"Number"}
                                        />
                                        <button
                                            type="button"
                                            className="app_link_btn"
                                        >
                                            Get App Link
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-5 dwnld_app_btn_sec">
                                <div className="row">
                                    <div className="dwnld_right">
                                        <p>More ways to get the App</p>
                                        <a
                                            href="https://play.google.com/store/apps/details?id=com.karvydistributor"
                                            target="_blank"
                                        >
                                            <Image src="/images/google_play.png" />
                                        </a>
                                        <a
                                            href="https://apps.apple.com/in/app/kfinkart-distributors/id1421782361"
                                            target="_blank"
                                        >
                                            <Image src="/images/app_store.png" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
        </div>
      </div>

      {/* download section end */}

      <HomeFooter />
    </div>
  );
}
